//用户按钮权限
import store from "../../store";

let perms = ""
let authority = function (el, binding, vnode, oldVnode) {
    perms = store.state.menuPerms
    for (let i = 0; i < store.state.menuPerms.length; i++) {
      if (binding.arg.split(':')[0] == perms[i].split(":")[0] && perms[i].split(":")[1] == "*") {
        break;
      }
      if (binding.arg == perms[i]) {
        break;
      }
      if (i == perms.length - 1) {
        if (binding.arg.split(':')[1] == 'updateStatus') {
          el.style.display = "none";
        } else {
          el.style.display = "none";
        }
      }
    }
  }

export default authority




// WEBPACK FOOTER //
// ./src/directives/src/authority.js